const getUniqueValues = (array) => [...new Set(array)];

export default getUniqueValues;
